// src/components/store/sections/faqs/FaqV91BentohelpIndigoPulse.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV91BentohelpIndigoPulse(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={91}
      archKey="bento_help"
      archLabel="Bento Help Matrix"
      palName="IndigoPulse"
      grad="from-indigo-500 via-blue-600 to-violet-700"
      lightBg="bg-indigo-50"
      textCol="text-indigo-700"
      borderCol="border-indigo-200"
      btnCls="bg-indigo-600 hover:bg-indigo-700"
      hexCol="#6366f1"
      {...props}
    />
  );
}
